import AcademicDatesDataStore from '../../datastores/AcademicDatesDataStore';

const data = {
  academic: {
    calendar: [
      {
        id: 1,
        career: 'PREG',
        title: 'Turno de matrícula - demo',
        name: 'Turno de matrícula - demo',
        description:
          'Conoce tu turno de matrícula: enviaremos a tu correo UTP el turno (día y hora) que te corresponde para realizar tu matrícula en línea',
        startDate: 1627516800000,
        endDate: 1627516800000,
        target: 'matricula.utp.edu.pe/',
        __typename: 'AcademicCalendar'
      },
      {
        id: 4,
        career: 'PREG',
        title: 'Exonerate del PSE',
        name: 'Exonerate del PSE',
        description:
          'Fecha límite para exonerarte del Programa de Salud Estudiantil  para el ciclo Agosto 2021',
        startDate: 1627603200000,
        endDate: 1627603200000,
        target: 'bit.ly/exoneratepse',
        __typename: 'AcademicCalendar'
      },
      {
        id: 5,
        career: 'PREG',
        title: 'Matrícula Extemporánea',
        name: 'Matrícula Extemporánea',
        description:
          'Matrícula Extemporanea. Podrás agregar cursos o modificar tus registros',
        startDate: 1628208000000,
        endDate: 1628380800000,
        target: '',
        __typename: 'AcademicCalendar'
      },
      {
        id: 7,
        career: 'PREG',
        title: 'Inicio de Clases',
        name: 'Inicio de Clases',
        description: 'Inicio de Clases Ciclo Agosto 2021',
        startDate: 1628467200000,
        endDate: 1628467200000,
        target: 'bit.ly/RutaUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 9,
        career: 'PREG',
        title: 'Vencimiento Cuota 1',
        name: 'Vencimiento de Cuotas',
        description:
          'Vencimiento Cuota 1: Hasta hoy  puedes acceder a los descuentos de pronto pago (hasta 5%). Desde mañana se incrementará una mora a tu cuota.',
        startDate: 1628812800000,
        endDate: 1628812800000,
        target: 'bit.ly/PagoUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 12,
        career: 'PREG',
        title: 'Retiro con recálculo de cuotas',
        name: 'Retiro de curso',
        description:
          'Fecha límite para solicitar retiro de cursos con recálculo de cuotas pendientes.',
        startDate: 1629504000000,
        endDate: 1629504000000,
        target: 'bit.ly/RetCurso',
        __typename: 'AcademicCalendar'
      },
      {
        id: 13,
        career: 'PREG',
        title: 'Convalidación de asignaturas',
        name: 'Convalidación de asignaturas',
        description: 'Fecha límite para solicitar convalidación de asignaturas',
        startDate: 1630454400000,
        endDate: 1630454400000,
        target:
          'saeutp.zendesk.com/hc/es/articles/217893243-Convalidaci%C3%B3n-de-Curso',
        __typename: 'AcademicCalendar'
      },
      {
        id: 15,
        career: 'PREG',
        title: 'Vencimiento Cuota 2',
        name: 'Vencimiento de Cuotas',
        description:
          'Vencimiento Cuota 2: Hasta hoy  puedes acceder a los descuentos de pronto pago (hasta 5%). Desde mañana se incrementará una mora a tu cuota.',
        startDate: 1631145600000,
        endDate: 1631145600000,
        target: 'bit.ly/PagoUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 19,
        career: 'PREG',
        title: 'Vencimiento Cuota 3',
        name: 'Vencimiento de Cuotas',
        description:
          'Vencimiento Cuota 3: Hasta hoy  puedes acceder a los descuentos de pronto pago (hasta 5%). Desde mañana se incrementará una mora a tu cuota.',
        startDate: 1633737600000,
        endDate: 1633737600000,
        target: 'bit.ly/PagoUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 23,
        career: 'PREG',
        title: 'Vencimiento Cuota 4',
        name: 'Vencimiento de Cuotas',
        description:
          'Vencimiento Cuota 4: Hasta hoy  puedes acceder a los descuentos de pronto pago (hasta 5%). Desde mañana se incrementará una mora a tu cuota.',
        startDate: 1636416000000,
        endDate: 1636416000000,
        target: 'bit.ly/PagoUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 26,
        career: 'PREG',
        title: 'Cambios carrera,campus y o modalidad',
        name: 'Solicitud de Cambios',
        description:
          'Fecha límite para solicitar cambio de carrera, campus y o modalidad para Verano 2022',
        startDate: 1637280000000,
        endDate: 1637280000000,
        target: 'saeutp.zendesk.com/hc/es/articles/360030458372',
        __typename: 'AcademicCalendar'
      },
      {
        id: 28,
        career: 'PREG',
        title: 'Retiro con recálculo de cuotas',
        name: 'Retiro de curso',
        description:
          'Fecha límite para solicitar retiro del periodo lectivo y de asignaturas sin recálculo de cuotas.',
        startDate: 1638489600000,
        endDate: 1638489600000,
        target: 'bit.ly/RetCurso',
        __typename: 'AcademicCalendar'
      },
      {
        id: 29,
        career: 'PREG',
        title: 'Exámenes finales',
        name: 'Exámenes finales',
        description: 'Exámenes finales',
        startDate: 1638748800000,
        endDate: 1639267200000,
        target: '',
        __typename: 'AcademicCalendar'
      },
      {
        id: 32,
        career: 'PREG',
        title: 'Vencimiento Cuota 5',
        name: 'Vencimiento de Cuotas',
        description:
          'Vencimiento Cuota 5: Hasta hoy  puedes acceder a los descuentos de pronto pago (hasta 5%). Desde mañana se incrementará una mora a tu cuota.',
        startDate: 1639008000000,
        endDate: 1639008000000,
        target: 'bit.ly/PagoUTP',
        __typename: 'AcademicCalendar'
      },
      {
        id: 33,
        career: 'PREG',
        title: 'Exámenes rezagados',
        name: 'Exámenes de rezagados',
        description: 'Exámenes rezagados',
        startDate: 1639180800000,
        endDate: 1639440000000,
        target: 'bit.ly/Rezagado',
        __typename: 'AcademicCalendar'
      },
      {
        id: 36,
        career: 'PREG',
        title: 'Programa de Salud Estudiantil',
        name: 'Exonerate del PSE',
        description:
          'Fecha límite para validar tu seguro vigente para el ciclo Verano 2022',
        startDate: 1639958400000,
        endDate: 1639958400000,
        target: 'bit.ly/exoneratepse',
        __typename: 'AcademicCalendar'
      }
    ],
    __typename: 'Academic'
  }
};

export default class AcademicDatesDataStoreMock
  implements AcademicDatesDataStore
{
  async getAcademicDates() {
    return data.academic.calendar;
  }
}
